<div>
  <div *ngIf="icone === ''">
    <h5>{{message}}</h5>
  </div>
  <div class="col-md-12" style="display: flex; justify-content: end;" *ngIf="icone !== ''">
    <mat-icon class="col-md-2 icon-display" [color]="iconColor">{{icone}}</mat-icon>
    <h5 class="col-md-9">{{message}}</h5>
  </div>
  <div class="col-md-12">
    <mat-divider></mat-divider>
  </div>
  <div class="col-md-12" style="margin-top: 20px; display: flex; justify-content: space-between;" *ngIf="ifBpListMode && (!bpDisplayState || !environment); else hideBp">
    <button mat-raised-button color="default" (click)="onModalCancel()">Retour</button>
  </div>
  
  <ng-template #hideBp>
    <div class="col-md-12" style="margin-top: 20px; display: flex; justify-content: space-between;">

      <button mat-raised-button color="default" (click)="onModalCancel()">Retour</button>

      <button mat-raised-button color="primary" *ngIf="this.data.statut === 'Validé' && this.data.bcType != this.definitionTypeBC.BCEnveloppe && this.canCreate" (click)="onModalConfirm('Compléter le BC')" style="margin-left: 40px;">Compléter le BC</button>

      <button mat-raised-button color="warn" *ngIf="this.data.statut === 'Validé' && this.data.bcType != this.definitionTypeBC.BCEnveloppe && this.canCreate" (click)="onModalConfirm('Annuler et refaire le BC')" style="margin-left: 40px;">Annuler et refaire le BC</button>

      <button mat-raised-button color="danger" *ngIf="this.canCreate" (click)="onOpenModalModifCancel()" style="margin-left: 40px;">Annuler définitivement le BC</button>

    </div>
  </ng-template>
</div>